import React from 'react';

import PropTypes from 'prop-types';

import { resolveArguments } from 'helpers/utils';

import { CountryName, FlagWrapper } from './styles';
import { LightFlagIcon } from '../common/fromAuth/LightFlagIcon/LightFlagIcon';
import { LightText } from '../common/fromAuth/LightText/LightText';

const GeoCountry = (props) => {
    const country = props.country;
    const countryFrom = props.countryFrom;
    const countryTo = props.countryTo;

    let uri = props.isRequest
        ? resolveArguments(props.uri, [country.seoNameFrom, countryTo.seoNameTo])
        : resolveArguments(props.uri, [countryFrom.seoNameFrom, country.seoNameTo]);

    return (
        <li>
            <a href={uri}>
                <FlagWrapper>
                    <LightFlagIcon name={country.code} size={'24px'} />
                </FlagWrapper>
                <CountryName>
                    <LightText ellipsis nowrap>
                        {country.name}
                    </LightText>
                </CountryName>
            </a>
        </li>
    );
};
GeoCountry.propTypes = {
    country: PropTypes.shape({
        name: PropTypes.string.isRequired,
        seoNameTo: PropTypes.string,
        seoNameFrom: PropTypes.string,
        code: PropTypes.string.isRequired,
        paySystems: PropTypes.array.isRequired,
    }).isRequired,
    countryFrom: PropTypes.shape({
        name: PropTypes.string.isRequired,
        seoNameTo: PropTypes.string,
        seoNameFrom: PropTypes.string,
        code: PropTypes.string.isRequired,
        paySystems: PropTypes.array.isRequired,
    }).isRequired,
    onlyMessages: PropTypes.shape({
        debit: PropTypes.string.isRequired,
        mastercard: PropTypes.string.isRequired,
        visa: PropTypes.string.isRequired,
        unionpay: PropTypes.string.isRequired,
    }).isRequired,
    uri: PropTypes.string.isRequired,
};
export default GeoCountry;
